import { render } from "./FooterCopy.vue?vue&type=template&id=0de7be13"
import script from "./FooterCopy.vue?vue&type=script&lang=js"
export * from "./FooterCopy.vue?vue&type=script&lang=js"

import "./FooterCopy.vue?vue&type=style&index=0&id=0de7be13&lang=scss"

import exportComponent from "/Users/yanislav.pavlov/development/private/bulgartabac/bulgartabac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__